import { Component, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import * as moment from 'moment';
import { AgreeOn } from 'src/app/models/agree-on';
import { ZbResponseStatusCodes } from 'src/app/models/zb-response';
import { MainAppService } from 'src/app/services/main-app.service';
import { AgreeDialogComponent } from '../../agree-dialog/agree-dialog.component';
import { InfoDialogComponent } from '../../info-dialog/info-dialog.component';

const MAX_DELETE_PERIOD_MONTHS = 6;

@Component({
  selector: 'app-data-delete',
  templateUrl: './data-delete.component.html',
  styleUrls: ['./data-delete.component.css']
})
export class DataDeleteComponent implements OnInit {

  maxDeletePeriodMonths = MAX_DELETE_PERIOD_MONTHS;
  dateFrom: Date;
  dateUntil: Date;
  isBusy: boolean = false;

  constructor(
    public dialog: MatDialog,
    public mainAppService: MainAppService) {}

  ngOnInit(): void { }

  get periodError(): string {
    if (!this.dateFrom || !this.dateUntil) {
      return "Select a start and end date.";
    }
    if (!moment(this.dateUntil).isBefore(moment(this.dateFrom).add(MAX_DELETE_PERIOD_MONTHS, 'months'))) {
      return "The period cannot exceed " + MAX_DELETE_PERIOD_MONTHS + " months.";
    }
    return "";
  }

  delete() {
    if (this.periodError || this.isBusy) {
      return;
    }

    this.isBusy = true;
    this.mainAppService.getHardDeleteMembersCount(new Date(this.dateFrom), new Date(this.dateUntil)).subscribe(retval => {
      this.isBusy = false;
      if (retval && retval.statusCode == ZbResponseStatusCodes.OK) {
        if (retval.responseData > 0) {
          this.confirmDelete(retval.responseData);
        }
        else {
          this.showInfo("No members found for the selected period. Nothing to delete.");
        }
      }
    }, () => {
      this.isBusy = false;
    });
  }

  confirmDelete(membersCount: number) {
    var dateFromString = moment(this.dateFrom).format('DD/MM/YYYY');
    var dateUntilString = moment(this.dateUntil).format('DD/MM/YYYY');

    var agreeDto = new AgreeOn();
    agreeDto.title = "Yes Delete Permanently"
    agreeDto.text = "WARNING: " + membersCount + " member(s) registered from " + dateFromString + " until " + dateUntilString + " and ALL their related data (products, payments and links, including trashed members) will be PERMANENTLY deleted. This action is irreversible and cannot be undone. Are you sure?"
    const dialogRef = this.dialog.open(AgreeDialogComponent, {
      width: '400px',
      data: agreeDto
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        this.isBusy = true;
        this.mainAppService.hardDeleteMembers(new Date(this.dateFrom), new Date(this.dateUntil)).subscribe(retval => {
          this.isBusy = false;
          if (retval && retval.statusCode == ZbResponseStatusCodes.OK) {
            this.showInfo(retval.responseData + " member(s) permanently deleted.");
            this.dateFrom = null;
            this.dateUntil = null;
          }
        }, () => {
          this.isBusy = false;
        });
      }
    });
  }

  showInfo(text: string) {
    var infoDto = new AgreeOn();
    infoDto.title = ""
    infoDto.text = text
    this.dialog.open(InfoDialogComponent, {
      width: '400px',
      data: infoDto
    });
  }
}
